<template>
    <div class="docs-status-ring">
        <svg :width="size" :height="size" :viewBox="'0 0 ' + size + ' ' + size" xmlns="http://www.w3.org/2000/svg"></svg>
        <div class="description">
            <div class="numbers">
                <div v-if="uiConfigs.done.number"><span class="bg-home-done" :title="uiConfigs.done.number + getAppropriateNoun(' done document', uiConfigs.done.number)">{{ uiConfigs.done.label }}</span></div>
                <div v-if="uiConfigs.skipped.number"><span class="bg-home-skipped" :title="uiConfigs.skipped.number + getAppropriateNoun(' skipped document', uiConfigs.skipped.number)">{{ uiConfigs.skipped.label }}</span></div>
                <div v-if="uiConfigs.todo.number"><span class="bg-home-todo" :title="uiConfigs.todo.number + getAppropriateNoun(' todo document', uiConfigs.todo.number)">{{ uiConfigs.todo.label }}</span></div>
                <div v-if="uiConfigs.total===0"><span>No Documents</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as d3 from 'd3';
import {getAppropriateNoun} from "@/utils";

export default {
    name: "DocsStatusRing",
    props: {
        counts: {
            type: Object,
            default() {
                return {
                    total: 0,
                    done: 0,
                    skipped: 0,
                    todo: 0,
                }
            }
        }
    },
    mounted() {
        this.render();
    },
    data() {
        return {
            size: 100
        }
    },
    computed: {
        uiConfigs() {
            const {total, todo, done, skipped} = this.counts;
            const simplifiedNumber = (n) => {
                return Math.round(n)
            };

            return {
                done: {
                    label: `${simplifiedNumber(done / total * 100)}% Done`,
                    number: done,
                },
                skipped: {
                    label: `${simplifiedNumber(skipped / total * 100)}% Skipped`,
                    number: skipped,
                },
                todo: {
                    label: `${simplifiedNumber(todo / total * 100)}% Todo`,
                    number: todo,
                },
                total,
            };
        }
    },
    methods: {
        render() {
            const drawArc = d3.arc()
                    .innerRadius(() => {
                        return 0
                    })
                    .outerRadius(() => {
                        return 50
                    })
                    .startAngle((d) => {
                        return d.startAngle
                    })
                    .endAngle((d) => {
                        return d.endAngle
                    });

            const data = [];
            const circleDegree = Math.PI * 2;
            const {total, todo, done, skipped} = this.counts;
            if (done) {
                data.push({
                    endAngle: circleDegree * done / total,
                    className: 'arc-path fill-home-done',
                    startAngle: 0,
                })
            }
            if (skipped) {
                data.push({
                    endAngle: circleDegree * (done + skipped) / total,
                    className: 'arc-path fill-home-skipped',
                    startAngle: circleDegree * done / total,
                })
            }
            if (todo) {
                data.push({
                    endAngle: circleDegree,
                    className: 'arc-path fill-home-todo',
                    startAngle: circleDegree * (done + skipped) / total,
                })
            }

            if (total === 0) {
                data.push({
                    endAngle: circleDegree,
                    className: 'arc-path fill-home-todo',
                    startAngle: 0
                })
            }

            const vis = d3.select(this.$el.firstElementChild);
            const arcs = vis.selectAll('path.arc-path').data(data);
            arcs.enter().append('svg:path')
                    .attr('class', (d) => (d.className))
                    .attr('transform', `translate(${this.size/2},${this.size/2})`)
                    .attr('d', drawArc)
        },
        getAppropriateNoun: getAppropriateNoun,
    }
}
</script>

<style scoped lang="scss">
.docs-status-ring {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .description {
        margin-left: 0.5rem;

        .numbers {
            div {
                margin: 0.32rem 0;

                span {
                    display: inline-block;
                    border-radius: 999px;
                    padding: 0.1rem 0.36rem;
                    font-size: 0.95em;
                }
            }
        }
    }
}
</style>
